// src/js/case-study.js
// Styles are linked in vline-case-study.html. Importing main.js here would
// make Parcel 1 move the CSS link off index.html.
import { initNav } from "./nav";

document.addEventListener("DOMContentLoaded", () => {
  initNav();
});
